import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBoxArchive, faCircleDown, faCircleUp, faClipboardCheck, faShareNodes, faTrash, faEllipsisVertical, } from '@fortawesome/free-solid-svg-icons';
import { Modal } from '../UI/Modal';
import { Code } from '../UI/Code';
import { CardSkeleton } from '../UI/CardSkeleton';
import { useClickOutside } from '../../hooks/ui';
import { configService } from '../../services/config.service';
const { playServer } = await configService.appConfig;
export const WordSearchListItem = ({ wordSearch, onStatusUpdate, onDelete, }) => {
    const optionsRef = useRef(null);
    const [isOptionsOpen, setIsOptionsOpen] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [copied, setCopied] = useState(false);
    // Use custom hook for options menu
    useClickOutside(optionsRef, () => {
        if (isOptionsOpen)
            setIsOptionsOpen(false);
    });
    /**
     * Handles successful code copy action
     */
    const handleCodeCopy = () => {
        setCopied(true);
    };
    const handleModalOpen = (event) => {
        event.preventDefault();
        setIsModalOpen(true);
        setCopied(false);
    };
    const handleModalClose = () => {
        setIsModalOpen(false);
    };
    const handleSubmissionsClick = (event) => {
        event.preventDefault();
        window.location.href = `/word-searches/${wordSearch.wordSearchId}/submissions`;
    };
    const handleStatusUpdate = (event) => {
        event.preventDefault();
        onStatusUpdate(wordSearch.wordSearchId, wordSearch.status === 'draft' ? 'published' : 'draft');
    };
    const handleDelete = (event) => {
        event.preventDefault();
        onDelete(wordSearch.wordSearchId);
    };
    return wordSearch.loading ? (React.createElement(CardSkeleton, { kreeda: wordSearch })) : (React.createElement(React.Fragment, null,
        wordSearch.code && (React.createElement(Modal, { id: wordSearch.code, component: Code, componentProps: {
                id: wordSearch.code,
                link: `${playServer}?code=${wordSearch.code}`,
                copied,
                onCopy: handleCodeCopy,
            }, isOpen: isModalOpen, onClose: handleModalClose })),
        ' ',
        React.createElement(Link, { className: "activity-item", to: `/word-searches/${wordSearch.wordSearchId}` },
            React.createElement("div", { className: "activity-header" },
                React.createElement("h3", null, wordSearch.name),
                React.createElement("div", { ref: optionsRef, className: "options-container" },
                    React.createElement("button", { className: "options-button", onClick: (event) => {
                            event.preventDefault();
                            setIsOptionsOpen(!isOptionsOpen);
                        } },
                        React.createElement(FontAwesomeIcon, { icon: faEllipsisVertical })),
                    React.createElement("div", { className: `options-menu ${isOptionsOpen ? 'show' : ''}` },
                        React.createElement("button", { onClick: handleSubmissionsClick },
                            React.createElement(FontAwesomeIcon, { icon: faClipboardCheck }),
                            "View Submissions"),
                        React.createElement("button", { onClick: (event) => {
                                event.preventDefault();
                            } },
                            React.createElement(FontAwesomeIcon, { icon: faBoxArchive }),
                            "Archive"),
                        React.createElement("button", { className: "delete-button", disabled: wordSearch.status !== 'draft', onClick: handleDelete },
                            React.createElement(FontAwesomeIcon, { icon: faTrash }),
                            "Delete")))),
            React.createElement("div", { className: "activity-meta" },
                wordSearch.duration && (React.createElement(React.Fragment, null,
                    React.createElement("span", null,
                        parseInt(wordSearch.duration) / 60,
                        " min"))),
                React.createElement("span", null,
                    wordSearch.wordsCount,
                    " word(s)"),
                React.createElement("span", null,
                    wordSearch.submissionsCount,
                    " submission(s)")),
            React.createElement("div", { className: "activity-actions" },
                React.createElement("button", { className: "btn--primary publish", onClick: handleStatusUpdate, disabled: wordSearch.wordsCount === 0 },
                    React.createElement(FontAwesomeIcon, { icon: wordSearch.status === 'draft' ? faCircleUp : faCircleDown }),
                    wordSearch.status === 'draft' ? 'Publish' : 'Unpublish'),
                React.createElement("button", { className: "btn--secondary share", value: wordSearch.code, onClick: handleModalOpen, disabled: wordSearch.status === 'draft' },
                    React.createElement(FontAwesomeIcon, { icon: faShareNodes }),
                    "Host")))));
};
